
<div class="ox_hidden " id="Cemex_incidendes_id">
  <div class="row m-0">
    <!-- <div class="col-lg-3 col-md-4 col-12 p-0 eventSection card-scroll_main">

     </div>-->
    <div class="col-lg-12 bod_left pr-0 pl-0">
      <!-- <div class="lb-head-single col-12">
         <h6 class="d-inline">"Incident files <span class="color_gray">retrieved based on our applied filters. </span>"</h6>
         <i data-toggle="modal" data-target="#AddNew_Case" tooltip="Filters" placement="left" class="fas fa-plus-circle pull-right font_20"></i>
       </div>-->

      <div class="card-scroll p-0" style="height: calc(100vh - 80px);">
        <div class="summarySection">
          <div class="row no-m">
            <div class="col-md-4  mt-1">
              <div class="file_details_section2">
                <div class="row no-m">
                  <div class="col-md-2 no-p text-center">
                    <div class="">
                      <i class="folder_icon2 fas fa-photo-video mr-05"></i>
                    </div>
                  </div>
                  <div class="col-md-10 no-p">
                    <div class="row no-m">
                      <div class="col-md-5 no-p">
                        <div>
                          <i class="far fa-car mr-05"></i>
                          <span class="video_box_drive_name pl-0">FN17BWB</span>
                        </div>

                      </div>
                      <div class="col-md-6 no-p text-right">
                        <div class="">
                          <i class="far fa-image mr-05"></i>
                          <div class="video_box_drive_name d-inline-block">
                            <p class="d-inline-block ">Complaints</p>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="row no-m">
                      <div class="col-md-10 no-p">

                        <div class="small_date_time">
                          <i class="fas fa-user mr-05"></i>
                          <span class="video_box_drive_name pl-0">2025-May-14 16:37:50</span>
                        </div>
                      </div>
                      <div class="col-md-2 no-p text-center">
                        <i class="far fa-arrow-alt-circle-right view_icon cursor-pointer" (click)="showEvent(0)"></i>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-4 pl-0  mt-1">
              <div class="file_details_section1">
                <div class="row no-m">
                  <div class="col-md-2 no-p text-center">
                    <div class="">
                      <i class="folder_icon1 fas fa-folder mr-05"></i>
                    </div>
                  </div>
                  <div class="col-md-10 no-p">
                    <div class="row no-m">
                      <div class="col-md-5 no-p">
                        <div>
                          <i class="far fa-car mr-05"></i>
                          <span class="video_box_drive_name pl-0">FN17BWB</span>
                        </div>

                      </div>
                      <div class="col-md-6 no-p text-right">
                        <div class="">
                          <i class="far fa-file-chart-pie mr-05"></i>
                          <div class="video_box_drive_name d-inline-block">
                            <p class="d-inline-block ">Environmental</p>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="row no-m">
                      <div class="col-md-10 no-p">

                        <div class="small_date_time">
                          <i class="fas fa-user mr-05"></i>
                          <span class="video_box_drive_name pl-0">2025-May-14 16:37:50</span>
                        </div>
                      </div>
                      <div class="col-md-2 no-p text-center">
                        <i class="far fa-arrow-alt-circle-right view_icon cursor-pointer" (click)="showEvent(0)"></i>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-4 pl-0 pr-0  mt-1">
              <div class="file_details_section3">
                <div class="row no-m">
                  <div class="col-md-2 no-p text-center">
                    <div class="">
                      <i class="folder_icon3 fas fa-file-pdf mr-05"></i>
                    </div>
                  </div>
                  <div class="col-md-10 no-p">
                    <div class="row no-m">
                      <div class="col-md-5 no-p">
                        <div>
                          <i class="far fa-car mr-05"></i>
                          <span class="video_box_drive_name pl-0">FN17BWB</span>
                        </div>

                      </div>
                      <div class="col-md-6 no-p text-right">
                        <div class="">
                          <i class="far fa-file-chart-pie mr-05"></i>
                          <div class="video_box_drive_name d-inline-block">
                            <p class="d-inline-block ">RTC</p>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="row no-m">
                      <div class="col-md-10 no-p">

                        <div class="small_date_time">
                          <i class="fas fa-user mr-05"></i>
                          <span class="video_box_drive_name pl-0">2025-May-14 16:37:50</span>
                        </div>
                      </div>
                      <div class="col-md-2 no-p text-center">
                        <i class="far fa-arrow-alt-circle-right view_icon cursor-pointer" (click)="showEvent(0)"></i>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>



          </div>


        </div>
      </div>



      <div class="livefoot">
        <div class="row no-m width_100pc">
          <div class="col-md-6">

          </div>
          <div class="col-md-6 text-right pr-0">

          </div>
        </div>

      </div>
    </div>

  </div>
</div>
